/**
 * A Google Maps link for whoever drives the order.
 *
 * The verified POINT when there is one — a pin or a geocoded address lands the
 * driver on the door, not on a search result. Falls back to searching the
 * address text, and to nothing when there is neither. Uses the documented
 * cross-platform URL (`/maps/search/?api=1`), which opens the app on a phone.
 */
export function mapsLink(
  point: { lat: number | null; lng: number | null } | null,
  address?: string | null,
): string | null {
  if (point && point.lat !== null && point.lng !== null) {
    return `https://www.google.com/maps/search/?api=1&query=${point.lat},${point.lng}`;
  }
  const text = address?.trim();
  return text ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(text)}` : null;
}
